import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Skeleton } from '@mui/material';

export default () => {
  return (
    <>
      {[1, 2, 3].map((key) => (
        <TableRow key={key}>
          <TableCell>
            <Skeleton height={40} />
          </TableCell>
          <TableCell>
            <Skeleton height={40} />
          </TableCell>
          <TableCell>
            <Skeleton height={40} />
          </TableCell>
          <TableCell>
            <Skeleton height={40} />
          </TableCell>
          <TableCell>
            <Skeleton height={40} />
          </TableCell>
          <TableCell>
            <Skeleton height={40} />
          </TableCell>
          <TableCell>
            <Skeleton variant="circular" width={25} />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};
